<template>
<div class="reg-wrap">
    <div class="email-inner" v-if="wayType==='email'">
        <notice-txt :txt="`${$t($loginLangPrefix('userSign.notreg'), {name: name})}`" />
        <password-input @changePassword="changePasswordHandle" @changePasswordError="changePasswordErrorHandle" @btnSure="send" />
        <error-tip :txt="passwordError"/>
        <code-input ref="codeinput" reg="reg" :name="name" @changeCode="changeCodeHandle" @changeCodeError="changeCodeErrorHandle" @btnSure="send" />
        <error-tip :txt="codeError" />
        <button-wrap :has="actBtn" :cover="cover" :txt="$t($loginLangPrefix('userSign.sendEmail'))" @btnSure="send" />
        <p class="have">{{$t($loginLangPrefix('userSign.haveaccount'))}}<a href="javascript:void(0);" @click="gotoLogin()">{{$t($loginLangPrefix('userSign.login'))}}</a></p>
    </div>
    <div class="memail-inner" v-if="wayType==='m-email'">
        <title-txt :txt="$t($loginLangPrefix('userSign.signIn'))" />
        <desc-txt :txt="`${$t($loginLangPrefix('userSign.notreg'), {name: name})}`" />
        <password-input mb="mb" @changePassword="changePasswordHandle" @changePasswordError="changePasswordErrorHandle" />
        <error-tip :txt="passwordError" mb="mb" />
        <code-input ref="codeinput" mb="mb" reg="reg" :name="name" @changeCode="changeCodeHandle" @changeCodeError="changeCodeErrorHandle" />
        <error-tip mb="mb" :txt="codeError" />
        <button-wrap mb="mb" :has="actBtn" :cover="cover" :txt="$t($loginLangPrefix('userSign.sendEmail'))" @btnSure="send" />
        <p class="have mb">{{$t($loginLangPrefix('userSign.haveaccount'))}}<a href="javascript:void(0);" @click="gotoLogin()">{{$t($loginLangPrefix('userSign.login'))}}</a></p>
    </div>
    <toast-pop v-show="toastState" :txt="txt" />
</div>
</template>
<script>

import error from '../common/error';
import logreg from '../js/logreg';

import notice from '../common/notice';
import title from '../common/title';
import desc from '../common/desc';
import passwordInput from '../common/password';
import codeInput from '../common/code';
import button from '../common/button';
import toast from '../common/toast';

export default {
  name: 'regwrap',
  props: {
    name: { type: String, default: '' },
    wayType: { type: String, default: '' }
  },
  data() {
    return {
      password: '',
      code: '',
      codeError: '',
      passwordError: '',
      cover: false,
      toastState: false,
      txt: ''
    };
  },
  computed: {
    actBtn() {
      return !!this.code && !this.codeError && !!this.password && !this.passwordError;
    }
  },
  components: {
    'error-tip': error,
    'desc-txt': desc,
    'title-txt': title,
    'notice-txt': notice,
    'password-input': passwordInput,
    'code-input': codeInput,
    'button-wrap': button,
    'toast-pop': toast
  },
  methods: {
    changeCodeErrorHandle(txt) {
      this.codeError = txt;
    },
    changeCodeHandle(code) {
      this.code = code;
    },
    changePasswordHandle(password) {
      this.password = password;
    },
    changePasswordErrorHandle(txt) {
      this.passwordError = txt;
    },
    send() {
      if (this.code && this.password && !this.passwordError && !this.codeError && !this.cover) {
        this.cover = true;
        logreg.register(this.name, this.password, this.code, '', '', logreg.REGTYPE.email, 1, (state, data) => {
          this.cover = false;
          if (state === 'tongdun_fail') {
            this.showPop('Network error,refresh retry');
            return;
          }
          if (state === 'success') {
            this.$emit('success', data);
          } else if ((window.errorMessageLoginTip && window.errorMessageLoginTip.indexOf(`${data.status}`) >= 0) || (window.errorMessageLoginTip && window.errorMessageLoginTip.indexOf(data.data && `${data.data.status}`) >= 0)) {
            // this.codeError = this.$t(this.$loginLangPrefix('userSign.fkError'));
          } else if (data.data && data.data.status === '4044') {
            this.$emit('inputEmail', 'sure', this.name, data.accessToken);
          } else if (data.errorMessageTMXTip) {
            //
          } else {
            if (this.$refs.codeinput) {
              this.$refs.codeinput.getVerify();
            }
            this.codeError = this.$t(this.$loginLangPrefix('userSign.codeError'));
          }
        });
      }
    },
    gotoLogin() {
      this.$emit('inputEmail', 'input', '', '');
    },
    showPop(txt) {
      this.txt = txt;
      this.toastState = true;
      setTimeout(() => {
        this.txt = '';
        this.toastState = false;
      }, 1500);
    }
  },

  mounted() {
  },

  beforeDestroy() {
  }
};
</script>
<style lang="scss" scoped>
@function rem($n) {
    @return ($n*1rem / 50);
}
.reg-wrap {
    position: relative;
    width: 100%;
    .have {
        margin-top: 10px;
        width: 100%;
        text-align: center;
        font-size:14px;
        font-family: 'RobotoRegular';
        font-weight: normal;
        color:rgba(153,153,153,1);
        line-height:14px;
        &.mb {
            margin-top: rem(10);
            line-height: rem(14);
        }
        a {
            color:#9D1DFF;
            text-decoration: underline;
            cursor: pointer;
        }
    }
}
</style>
